export const ROLES = {
    user: 'user',
    performer: 'performer',
};
